import { gql, useMutation } from '@apollo/client'
import { Alert } from '@mapped/rivet/dist/mui/material'
import { PersonalAccessToken } from '@mapped/schema-graph-react-apollo'
import { FunctionComponent, useContext, useEffect, useState } from 'react'

import { UserContext } from '../../../../contexts/user'
import { useModals } from '../../../../hooks/useModals'
import { EStepToken } from '../../../../types/general'
import { logger } from '../../../../utils/logger'
import { AuthenticationModal } from '../../../auth/authenticationModal'
import { IScopesDescription } from './index'
import Step1 from './step1'
import Step2 from './step2'
import Step3 from './step3'

export const AccessToken: FunctionComponent<ITokenPage> = ({
  scopesDescription,
  tokensList,
  isLogged,
}) => {
  const [currentStep, setCurrentStep] = useState<EStepToken>(EStepToken.IDLE)
  const [newToken, setNewToken] = useState('')
  const { permissions, user } = useContext(UserContext)
  const modals = useModals()

  const [createPersonalAccessToken, { data: responseCreateMutation }] =
    useMutation(CREATE_PERSONAL_ACCESS_TOKEN_MUTATION, {
      ignoreResults: false,
      onError: (err) => logger.error('[create pat mutation error]', err),
    })

  useEffect(() => {
    if (responseCreateMutation?.createPersonalAccessToken?.token) {
      setNewToken(responseCreateMutation.createPersonalAccessToken.token)
    }
  }, [responseCreateMutation])

  if (!isLogged) {
    return (
      <Alert color="warning" sx={{ alignSelf: 'flex-start' }}>
        <a
          href="#"
          onClick={() => modals.open(AuthenticationModal)}
          style={{ color: 'inherit', fontWeight: 'bold' }}
        >
          Click here to sign in
        </a>{' '}
        and start managing your Personal Access Tokens.
      </Alert>
    )
  }

  switch (currentStep) {
    case EStepToken.IDLE:
    default:
      return (
        <Step1
          setCurrentStep={setCurrentStep}
          tokensList={tokensList}
          tokenLoading={false}
        />
      )
    case EStepToken.NEW:
      return (
        <Step2
          setCurrentStep={setCurrentStep}
          createPersonalAccessToken={createPersonalAccessToken}
          permissions={permissions}
          scopesDescription={scopesDescription}
          user={user}
        />
      )
    case EStepToken.GENERATED:
      return <Step3 setCurrentStep={setCurrentStep} newToken={newToken} />
  }
}

const tokenData = `
  token
  pat {
    id
    userId
    name
    permissions
    created
    updated
    lastExchanged
  }
`

const CREATE_PERSONAL_ACCESS_TOKEN_MUTATION = gql`
  mutation CreatePersonalAccessTokenRequest(
    $input: PersonalAccessTokenCreateRequestInput
  ) {
    createPersonalAccessToken(input: $input) {
      ${tokenData}
    }
  }
`

interface ITokenPage {
  scopesDescription: IScopesDescription[]
  tokensList: PersonalAccessToken[]
  isLogged?: boolean
}
